export enum CarouselVariant {
  CAROUSEL_VARIANT_UNKNOWN = 'CAROUSEL_VARIANT_UNKNOWN',
  /**
   * title
   * tile, tile, tile, ...  Web + App
   */
  CAROUSEL_VARIANT_DEFAULT = 'CAROUSEL_VARIANT_DEFAULT',
  /**
   * title | tile, tile, tile, ...  Web only
   * @deprecated
   */
  CAROUSEL_VARIANT_TITLE_LEFT = 'CAROUSEL_VARIANT_TITLE_LEFT',
  /**
   * title
   * tile1, tile3, tile5, ...
   * tile2, tile4, .....
   */
  CAROUSEL_VARIANT_TWO_ROW = 'CAROUSEL_VARIANT_TWO_ROW',
}
